var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#548CD2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4998 20.8333L18.8213 19.5118C19.4722 18.861 20.5275 18.861 21.1783 19.5118L22.4998 20.8333M19.9998 19.1667V23.3333M28.3332 18.3333V24.1667C28.3332 26.0076 26.8408 27.5 24.9998 27.5H14.9998C13.1589 27.5 11.6665 26.0076 11.6665 24.1667V15.8333C11.6665 13.9924 13.1589 12.5 14.9998 12.5H17.2221C17.9433 12.5 18.6451 12.7339 19.2221 13.1667L20.7776 14.3333C21.3546 14.7661 22.0564 15 22.7776 15H24.9998C26.8408 15 28.3332 16.4924 28.3332 18.3333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/fileUpload.8e281af9dbdfd672dd75c9d498fcf17c.svg";
export { ForwardRef as ReactComponent };